import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'app-navbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LucideAngularModule],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  scrolled  = input(false);
  isDark    = input(false);
  links     = input<{ label: string; href: string }[]>([]);
  portalUrl = input('');

  toggleDark = output<void>();
  openMenu   = output<void>();
}
